module.exports = __webpack_public_path__ + "img/temp.a7a19176.svg";